import axios from "axios";
import Config from "@/config";
import authHeader from "@/services/auth-header";

class NotificationService {
    getItems(params = {}) {
        return axios.get(Config.apiBasePath + '/notifications', {headers: authHeader(), params});
    }

    readItem(id) {
        return axios.patch(Config.apiBasePath + '/notifications/' + id, {}, {headers: authHeader()});
    }

    markAllAsRead() {
        return axios.patch(Config.apiBasePath + '/notifications', {}, {headers: authHeader()});
    }
}

export default new NotificationService();
